import { Avatar, Box } from "@mui/material";
import React from "react";
import logo from "../assets/images/Logo/transparency background/Little Haiti Global-08.png";
import Accountmenu from "../customComponents/accounts/AccountMenu";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { s3baseUri } from "../../config/config";
import { useAdminContext } from "../../hooks/UseAdminContext";
import { useNavigate } from "react-router-dom";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import UserIcon from "../assets/images/user.png";

export default function DashboardHeader() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { userInfo } = useAdminContext();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <header className="dashboard-header d-flex justify-content-between align-items-center position-relative">
        <div className="header-left">
          <div className="d-flex align-items-center container">
            <div
              style={{ borderRadius: "50%", cursor: "pointer" }}
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              <img className="logo" src={logo} alt="Logo" />
            </div>
          </div>
        </div>

        <div
          className="position-absolute w-100 text-center"
          style={{
            pointerEvents: "none",
            color: "#fec013",
          }}
        >
          <h1 className="m-0" style={{ color: "#fec013" }}>
            LHG E-Portal
          </h1>
        </div>

        <div className="header-right">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              cursor: "pointer",
            }}
            onClick={
              localStorage?.getItem("code-verified")
                ? handleMenuOpen
                : () => navigate("/support")
            }
          >
            {localStorage?.getItem("code-verified") ? (
              <>
                <Avatar
                  src={
                    userInfo?.profile_image
                      ? s3baseUri + userInfo.profile_image
                      : ""
                  }
                  sx={{ width: 46, height: 46, border: "none" }}
                >
                  {!userInfo?.profile_image &&
                    userInfo?.name
                      ?.split(" ")
                      .map((n) => n[0])
                      .slice(0, 2)
                      .join("")}
                </Avatar>
                {open ? (
                  <ExpandLess
                    sx={{
                      position: "absolute",
                      backgroundColor: "white",
                      color: "black",
                      bottom: 1,
                      right: -5,
                      fontSize: "15px",
                      borderRadius: "50px",
                    }}
                  />
                ) : (
                  <ExpandMore
                    sx={{
                      backgroundColor: "white",
                      color: "black",
                      position: "absolute",
                      bottom: 1,
                      right: -5,
                      fontSize: "15px",
                      borderRadius: "50px",
                    }}
                  />
                )}
              </>
            ) : (
              <>
                <SupportAgentIcon
                  className="me-md-2 me-1"
                  sx={{ fontSize: 30, color: "#fff" }}
                />
                Support
              </>
            )}
          </Box>
        </div>
      </header>
      <Accountmenu anchorEl={anchorEl} open={open} handleClose={handleClose} />
    </>
  );
}
